import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Col, Row } from "reactstrap";

import { SubmitButton } from "../common/buttons.jsx";
import { tr } from "../../utils/translation.js";
import { FormInput } from "../form/inputs.jsx";

/**
 * Form used to collect new e-mail address
 */
let ChangeEmailForm = (props) => {
  return (
    // #32937, disable auto complete
    <form onSubmit={props.handleSubmit} autoComplete="off">
      <h2>{tr("changeEmail")}</h2>
      <Row>
        <Col sm={12}>
          <Field name="email" component={FormInput} label={tr("email")} />
        </Col>
        <Col sm={12}>
          <div className="float-right">
            <SubmitButton submitting={props.submitting} text={tr("replace")} />
          </div>
        </Col>
      </Row>
    </form>
  );
};

ChangeEmailForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  newEmail: state.form.changeEmailForm,
});

ChangeEmailForm = connect(mapStateToProps)(ChangeEmailForm);

export default reduxForm({
  form: "changeEmailForm",
})(ChangeEmailForm);
